import { useTranslation } from 'react-i18next'
import { Phone, BadgeCheck, ShieldCheck } from 'lucide-react'

export default function TopPromiseBar() {
  const { t } = useTranslation()

  return (
    <div className="bg-gcg-dark text-white text-xs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ul className="flex items-center justify-center sm:justify-between gap-4 py-1.5 whitespace-nowrap">
          <li className="hidden sm:flex items-center gap-1.5 shrink-0">
            <BadgeCheck className="h-3.5 w-3.5 text-gcg-orange" aria-hidden="true" />
            <span>{t('shop.promiseBar.authority')}</span>
          </li>
          <li className="hidden sm:flex items-center gap-1.5 shrink-0">
            <ShieldCheck className="h-3.5 w-3.5 text-gcg-orange" aria-hidden="true" />
            <span>{t('shop.promiseBar.returns')}</span>
          </li>
          <li className="flex items-center gap-1.5 shrink-0">
            <Phone className="h-3.5 w-3.5 text-gcg-orange" aria-hidden="true" />
            <a href="tel:+31299705078" className="hover:text-gcg-orange transition-colors">
              <span className="hidden sm:inline">{t('shop.promiseBar.engineer')} </span>
              +31&nbsp;299&nbsp;705&nbsp;078
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}
